import React from 'react';
import CalendarioCampi from '../campi/CalendarioCampi';

export default function CampiCliente() {
  return (
    <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
      <h1 style={{ fontFamily: "'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight: 800, letterSpacing: '2px', marginBottom: '6px' }}>
        AFFITTO CAMPO
      </h1>
      <p style={{ color: '#666', fontSize: 'var(--font-size-sm)', marginBottom: '24px' }}>
        Prenota uno slot libero. Riceverai conferma via email con le istruzioni per il pagamento.
      </p>
      <CalendarioCampi/>
    </div>
  );
}
